import Toastify from 'toastify-js'

window.Toastify = Toastify

Toastify.show = (response) => {
  const info = response.message || response.info || response.notice
  const warn = response.warn || response.warning
  const error = response.error || response.danger

  const opts = {
    duration: 3000,
    position: 'right',
    gravity: 'bottom',
    avatar: '',
    close: false,
    style: {
      background: "lightblue",
      borderRadius: '5px',
      color: '#222',
      fontSize: '18px'
    }
  }

  if (info) {
    opts.text = info
  } else if (warn) {
    opts.text = warn
    opts.style.background = 'yellow'
  } else if (error) {
    opts.text = error
    opts.style.background = 'red'
    opts.style.color = 'white'
  }

  if (opts.text) {
    Toastify(opts).showToast();
  } else {
    alert(JSON.stringify(response, null, 2))
  }
}

Toastify.info = (msg) => Toastify.show({info: msg})
Toastify.error = (msg) => Toastify.show({error: msg})
